import fetch from 'auth/FetchInterceptor'

const whitelabelService = {}

whitelabelService.getWhitelabelUsers = function () {
    return fetch({
        url: '/whitelabel/users',
        method: 'get'
    })
}

whitelabelService.addWhiteLabelUser = function (data) {
    return fetch({
        url: '/whitelabel/user',
        method: 'post',
        data
    })
}

whitelabelService.updateWhiteLabelUser = function (id,data) {
    return fetch({
        url: `/whitelabel/user/${id}`,
        method: 'put',
        data
    })
}

whitelabelService.deleteWhiteLabelUser = function (id) {
    return fetch({
        url: `/whitelabel/user/${id}`,
        method: 'delete'
    })
}

whitelabelService.addWhiteLabelSettinngs = function (data) {
    return fetch({
        url: '/whitelabel/settings',
        method: 'post',
        data
    })
}

whitelabelService.getWhiteLabelSettings = function () {
    return fetch({
        url: '/whitelabel/settings',
        method: 'get'
    })
}

whitelabelService.getDataFromDomain = function (domain) {
    return fetch({
        url: `/search-by-domain`,
        method: 'post',
        data: domain
    })
}

whitelabelService.saveSmtpSettings = function (data) {
    return fetch({
        url: '/whitelabel/smtp-settings',
        method: 'post',
        data
    })
}

whitelabelService.testSmtpSettings = function (data) {
    return fetch({
        url: '/whitelabel/smtp-test',
        method: 'post',
        data
    })
}


export default whitelabelService